module.exports = __webpack_public_path__ + "static/img/shipinyinliao.5f2c05f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/shipinyinliao.jpg
// module id = HryZ
// module chunks = 0